module.exports = __webpack_public_path__ + "static/profile-pic.3cc2b7a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic.jpg
// module id = 472
// module chunks = 114276838955818